import { environment } from 'src/environment';
import { Component, Input, OnInit } from '@angular/core';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { BaseService, StorageService } from 'src/app/core/services';
import { DatalayerService } from 'src/app/core/services/datalayer.service';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { NgClass, NgIf } from '@angular/common';

@Component({
  selector: 'app-card-plan',
  templateUrl: './card-plan.component.html',
  styleUrls: ['./card-plan.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass],
})
export class CardPlanComponent implements OnInit {

  @Input() plan;
  @Input() selectedPlan;
  @Input() selectedPopular;
  skinName = environment.skinName;
  constructor(public configService: ConfigurationService, public storageService: StorageService,
    public datalayerService: DatalayerService, private baseService: BaseService, private susbscriptionService: SubscriptionService) {
  }

  ngOnInit(): void {
  }

  selectPlan(plan) {
    this.baseService.selectPlan = plan.plan;
    this.susbscriptionService.planDetails.plan = plan;
    const datalayerData = {
      event: 'GAEvent',
      eventCategory: 'Payment',
      eventAction: 'View',
      eventLabel: plan.title,
      platform: this.baseService.browserType,
      loginStatus: 'True',
      userId: (this.storageService.getLocalStore('u_id') ? this.storageService.getLocalStore('u_id') : ''),
      notificationStatus: localStorage.getItem('emailNotify') || 'False',
      region: (this.storageService.getLocalStore('region') ? this.storageService.getLocalStore('region') : ''),
      userType: this.storageService.getLocalStore('user_type'),
    };
    this.datalayerService.addDatalayer(datalayerData);
  }


}
